import { render, staticRenderFns } from "./StuNumStatistics.vue?vue&type=template&id=7d413d5e&scoped=true&"
import script from "./StuNumStatistics.vue?vue&type=script&lang=js&"
export * from "./StuNumStatistics.vue?vue&type=script&lang=js&"
import style0 from "./StuNumStatistics.vue?vue&type=style&index=0&id=7d413d5e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d413d5e",
  null
  
)

export default component.exports